import '@assets/css/global.scss'
// import { NavigationMenu } from '@shopify/app-bridge-react'
import { Frame } from '@shopify/polaris'
import '@shopify/polaris/build/esm/styles.css'
import { useEffect, useMemo, useRef } from 'react'
import TagManager from 'react-gtm-module'

export default function PolarisLayout(props: {
  children: React.ReactNode
  noFrame?: boolean
}) {
  const { noFrame } = props

  const tagManagerArgs = useMemo(
    () => ({
      gtmId: 'GTM-5VGTS7Q',
    }),
    [],
  )

  const gtmInitRef = useRef(false)
  useEffect(() => {
    if (noFrame) return
    if (gtmInitRef.current) return
    gtmInitRef.current = true
    TagManager.initialize(tagManagerArgs)
  }, [noFrame, tagManagerArgs])

  return noFrame ? (
    props.children
  ) : (
    <Frame>
      <div style={{ paddingBottom: '24px' }}>{props.children}</div>
    </Frame>
  )
}
